package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.custumcomponents.YouTubeShort
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px

@Composable
fun VideoRow(
    ids: List<String>,
    isMobile: Boolean,
    topPadding: CSSSizeValue<CSSUnit.px> = 50.px,
) = if (isMobile) {
    // Ecrã estreito não cabe 4 vídeos de 315px lado a lado -> scroll horizontal
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = topPadding.let { if (it == 80.px) 32.px else 24.px }, leftRight = 16.px)
            .styleModifier {
                property("overflow-x", "auto")
                property("scroll-snap-type", "x mandatory")
                property("-webkit-overflow-scrolling", "touch")
            },
        horizontalArrangement = Arrangement.Center,
    ) {
        ids.forEachIndexed { index, id ->
            Box(modifier = Modifier.styleModifier { property("scroll-snap-align", "center") }) {
                YouTubeShort(videoId = id, width = 180.px)
            }
            if (index != ids.lastIndex) Box(modifier = Modifier.width(12.px))
        }
    }
} else {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = topPadding, right = 100.px, left = 100.px),
        horizontalArrangement = Arrangement.Center
    ) {
        ids.forEachIndexed { index, id ->
            Column { YouTubeShort(videoId = id) }
            if (index != ids.lastIndex) Box(modifier = Modifier.width(40.px))
        }
    }
}